<template>
    <div class="shipment_add">
        <!-- 头部 -->
        <div class="detail_header">
            <div class="back_btn" @click="$router.back()">
                <van-icon name="arrow-left" size="24" />
            </div>
            <span class="header_title">新增发货</span>
            <div class="placeholder"></div>
        </div>

        <!-- 表单内容 -->
        <div class="form_content">
            <van-form @submit="onSubmit">
                <van-field
                    v-model="formData.shipment_type_text"
                    type="select"
                    label="发货类型"
                    placeholder="请选择"
                    readonly
                    @click="showShipmentTypeSelect = true"
                    is-link
                    required
                />
                <van-field
                    v-model="formData.record_name"
                    type="select"
                    label="名称"
                    placeholder="请选择"
                    readonly
                    @click="showRecordSelect = true"
                    is-link
                    v-if="formData.shipment_type !== 'other'"
                    required
                />
                <van-field
                    v-model="formData.custom_name"
                    label="自定义名称"
                    placeholder="请输入名称"
                    clearable
                    v-if="formData.shipment_type === 'other'"
                    required
                />
                <van-field
                    v-model="formData.studio_name"
                    type="select"
                    label="项目"
                    placeholder="请选择（选填）"
                    readonly
                    @click="showStudioSelect = true"
                    is-link
                />
                <van-field
                    v-model="formData.sale_user_name"
                    type="select"
                    label="销售人员"
                    placeholder="请选择"
                    readonly
                    @click="showSaleUserSelect = true"
                    is-link
                    required
                />
                <van-field
                    v-model="formData.shipment_num"
                    type="number"
                    label="发货数量"
                    placeholder="请输入数量"
                    clearable
                    required
                />
                <div class="stock_hint" v-if="currentStockNum > 0">
                    当前库存：{{currentStockNum}}
                </div>
                <van-field
                    v-model="formData.receiver_name"
                    label="收货人"
                    placeholder="请输入收货人姓名"
                    clearable
                    required
                />
                <van-field
                    v-model="formData.receiver_tel"
                    label="联系电话"
                    type="tel"
                    placeholder="请输入联系电话"
                    clearable
                    required
                />
                <van-field
                    v-model="formData.receiver_area"
                    label="所在地区"
                    placeholder="请选择或输入省市区"
                    readonly
                >
                    <template #button>
                        <van-button size="small" @click.prevent.stop="openAreaSelect">
                            选择
                        </van-button>
                    </template>
                </van-field>
                <van-field
                    v-model="formData.receiver_detail"
                    rows="2"
                    type="textarea"
                    label="详细地址"
                    placeholder="请输入详细地址"
                    clearable
                    required
                />
                <van-field
                    v-model="formData.remark"
                    type="textarea"
                    rows="2"
                    label="备注"
                    placeholder="选填"
                />
                <div class="submit_btn">
                    <van-button type="primary" native-type="submit" block round>
                        提交
                    </van-button>
                </div>
            </van-form>
        </div>

        <!-- 发货类型选择器 -->
        <van-popup v-model="showShipmentTypeSelect" position="bottom" round>
            <van-picker
                ref="shipmentTypePicker"
                show-toolbar
                :columns="shipmentTypeList"
                value-key="text"
                @confirm="onShipmentTypeConfirm"
                @cancel="showShipmentTypeSelect = false"
            />
        </van-popup>

        <!-- 产品/物料选择器 -->
        <van-popup v-model="showRecordSelect" position="bottom" round style="height: 70%;">
            <div class="picker_with_search">
                <van-search
                    v-model="recordSearchKey"
                    placeholder="搜索"
                    shape="round"
                    @change="filterRecordList"
                />
                <van-picker
                    ref="recordPicker"
                    show-toolbar
                    :columns="filteredRecordList"
                    value-key="text"
                    @confirm="onRecordConfirm"
                    @cancel="showRecordSelect = false"
                />
            </div>
        </van-popup>

        <!-- 项目选择器 -->
        <van-popup v-model="showStudioSelect" position="bottom" round style="height: 70%;">
            <div class="picker_with_search">
                <van-search
                    v-model="studioSearchKey"
                    placeholder="搜索"
                    shape="round"
                    @change="filterStudioList"
                />
                <van-picker
                    ref="studioPicker"
                    show-toolbar
                    :columns="filteredStudioList"
                    value-key="text"
                    @confirm="onStudioConfirm"
                    @cancel="showStudioSelect = false"
                />
            </div>
        </van-popup>

        <!-- 销售人员选择器 -->
        <van-popup v-model="showSaleUserSelect" position="bottom" round>
            <van-picker
                ref="saleUserPicker"
                show-toolbar
                :columns="saleUserList"
                value-key="text"
                @confirm="onSaleUserConfirm"
                @cancel="showSaleUserSelect = false"
            />
        </van-popup>

        <!-- 地区选择器 -->
        <van-popup v-model="showAreaSelect" position="bottom" round>
            <van-area
                ref="areaPicker"
                :area-list="areaList"
                v-model="areaValue"
                :columns-num="3"
                title="请选择地区"
                @confirm="onAreaConfirm"
                @cancel="showAreaSelect = false"
            />
        </van-popup>
    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import studio_tool_api from '@/api/teaching_studio_tool.js'
import until from '@/api/until.js'
import { areaList } from '@vant/area-data'

export default {
    name: 'ShipmentAdd',
    data() {
        return {
            showShipmentTypeSelect: false,
            showRecordSelect: false,
            showStudioSelect: false,
            showSaleUserSelect: false,
            showAreaSelect: false,
            areaValue: '',  // 用于 van-area 的默认值（字符串格式）
            
            shipmentTypeList: [
                { text: '产品', value: 'product' },
                { text: '物料', value: 'material' },
                { text: '其他', value: 'other' }
            ],
            
            recordList: [],
            filteredRecordList: [],
            recordSearchKey: '',
            
            studioList: [],
            filteredStudioList: [],
            studioSearchKey: '',
            
            saleUserList: [],
            
            areaList: areaList,
            
            currentStockNum: 0,
            
            formData: {
                shipment_type: '',
                shipment_type_text: '',
                record_id: '',
                record_name: '',
                custom_name: '',
                studio_id: '',
                studio_name: '',
                sale_user_id: '',
                sale_user_name: '',
                shipment_num: '',
                receiver_name: '',
                receiver_tel: '',
                receiver_area: '',
                receiver_area_code: '',
                receiver_detail: '',
                remark: '',
                shipment_photos: ''
            }
        }
    },
    mounted() {
        document.title = "新增发货"
        this.getStudioList()
        this.getSaleUserList()
        // 检查是否是编辑模式
        const id = this.$route.query.id
        const action = this.$route.query.action
        if (id && action === 'edit') {
            this.loadDetail(id)
        }
    },
    methods: {
        // 加载详情（编辑模式）
        async loadDetail(id) {
            this.$toast.loading({ message: '加载中...', duration: 0 })
            
            try {
                let res = await studio_api.Teaching_studio_apiIotmaxShipmentDetailGet({
                    app_id: this.$root.app_id,
                    id: id
                })
                
                this.$toast.clear()
                
                if (res.errcode === 0 && res.other) {
                    const data = res.other
                    // 填充表单数据
                    this.formData.shipment_type = data.shipment_type
                    this.formData.shipment_type_text = this.getShipmentTypeText(data.shipment_type)
                    this.formData.record_id = data.record_id || data.id
                    this.formData.record_name = data.record_name
                    this.formData.intro = data.intro
                    this.formData.studio_id = data.studio_id
                    this.formData.studio_name = data.studio_name
                    this.formData.sale_user_id = data.sale_user_id
                    this.formData.sale_user_name = data.sale_user_name
                    this.formData.shipment_num = data.shipment_num
                    this.formData.remark = data.remark || ''
                    this.formData.shipment_photos = data.shipment_photos || ''
                    
                    // 解析地址信息
                    if (data.shipment_address_info) {
                        this.parseAddressInfo(data.shipment_address_info)
                    }
                } else {
                    this.$toast('加载详情失败')
                }
            } catch (e) {
                this.$toast.clear()
                console.error('加载详情失败', e)
                this.$toast('加载详情失败')
            }
        },
        
        // 解析地址信息
        parseAddressInfo(addressInfo) {
            if (!addressInfo) return
            
            // 尝试 JSON 解析
            if (addressInfo.includes('{')) {
                try {
                    const info = JSON.parse(addressInfo)
                    this.formData.receiver_name = info.name || info.receiver_name || ''
                    this.formData.receiver_tel = info.phone || info.tel || ''
                    // 地址可能包含省市区和详细地址
                    const fullAddress = info.address || ''
                    this.parseFullAddress(fullAddress)
                    return
                } catch(e) {
                    // JSON 解析失败，继续尝试其他格式
                }
            }
            
            // 尝试逗号分隔格式：姓名，电话，地址
            const parts = addressInfo.split(',')
            if (parts.length >= 3) {
                this.formData.receiver_name = parts[0].trim()
                this.formData.receiver_tel = parts[1].trim()
                // 地址部分可能包含省市区和详细地址
                const fullAddress = parts.slice(2).join(',').trim()
                this.parseFullAddress(fullAddress)
            }
        },
        
        // 解析完整地址（区分省市区和详细地址）
        parseFullAddress(fullAddress) {
            if (!fullAddress) return
            
            console.log('解析地址:', fullAddress)
            console.log('areaList 结构:', {
                province_list_keys: Object.keys(this.areaList.province_list),
                city_list_keys: Object.keys(this.areaList.city_list),
                county_list_keys: Object.keys(this.areaList.county_list)
            })
            
            // 尝试从 areaList 中匹配省市区
            const provinceList = this.areaList.province_list
            const cityList = this.areaList.city_list
            const countyList = this.areaList.county_list
            
            let remainingAddress = fullAddress
            let provinceCode = ''
            let provinceName = ''
            let cityCode = ''
            let cityName = ''
            let countyCode = ''
            let countyName = ''
            
            // 匹配省份（按名称长度排序，优先匹配长的）
            const sortedProvinces = Object.entries(provinceList).sort((a, b) => b[1].length - a[1].length)
            for (const [code, name] of sortedProvinces) {
                if (remainingAddress.startsWith(name)) {
                    provinceCode = code
                    provinceName = name
                    remainingAddress = remainingAddress.substring(name.length)
                    console.log('匹配省份:', provinceName, code)
                    break
                }
            }
            
            if (!provinceCode) {
                // 无法匹配省份，全部作为详细地址
                console.log('无法匹配省份')
                this.formData.receiver_detail = fullAddress
                return
            }
            
            console.log('省份代码:', provinceCode)
            console.log('剩余地址:', remainingAddress)
            
            // @vant/area-data 的 city_list 结构是 { 城市代码：城市名称 }，不是嵌套的
            // 需要遍历所有城市，找到属于该省份的城市
            const provincePrefix = provinceCode.substring(0, 2)
            console.log('省份前缀:', provincePrefix)
            
            // 匹配城市（按名称长度排序，优先匹配长的）
            const allCities = Object.entries(cityList)
            const provinceCities = allCities.filter(([code]) => code.startsWith(provincePrefix))
            console.log('该省份的城市:', provinceCities)
            const sortedCities = provinceCities.sort((a, b) => b[1].length - a[1].length)
            for (const [code, name] of sortedCities) {
                console.log('尝试匹配城市:', name, '剩余地址:', remainingAddress)
                if (remainingAddress.startsWith(name)) {
                    cityCode = code
                    cityName = name
                    remainingAddress = remainingAddress.substring(name.length)
                    console.log('匹配城市:', cityName, code)
                    break
                }
            }
            
            // 匹配区县（按名称长度排序，优先匹配长的）
            if (cityCode) {
                const cityPrefix = cityCode.substring(0, 4)
                const allCounties = Object.entries(countyList)
                const cityCounties = allCounties.filter(([code]) => code.startsWith(cityPrefix))
                console.log('该城市的区县:', cityCounties)
                const sortedCounties = cityCounties.sort((a, b) => b[1].length - a[1].length)
                for (const [code, name] of sortedCounties) {
                    if (remainingAddress.startsWith(name)) {
                        countyCode = code
                        countyName = name
                        remainingAddress = remainingAddress.substring(name.length)
                        console.log('匹配区县:', countyName, code)
                        break
                    }
                }
            }
            
            // 设置省市区
            this.formData.receiver_area = provinceName + cityName + (countyName || '')
            this.formData.receiver_area_code = countyCode || cityCode || provinceCode
            
            // 剩余部分作为详细地址
            this.formData.receiver_detail = remainingAddress.trim()
            
            console.log('解析结果:', {
                receiver_area: this.formData.receiver_area,
                receiver_area_code: this.formData.receiver_area_code,
                receiver_detail: this.formData.receiver_detail
            })
        },
        
        // 获取发货类型文本
        getShipmentTypeText(type) {
            const texts = {
                product: '产品',
                material: '物料',
                other: '其他'
            }
            return texts[type] || '-'
        },
        
        // 获取项目列表
        async getStudioList() {
            try {
                let res = await studio_api.Teaching_studio_apiStudioWechatStudioGet({
                    app_id: this.$root.app_id
                })
                if (res.errcode === 0 && res.other) {
                    let listData = Array.isArray(res.other) ? res.other : (res.other.list || [])
                    this.studioList = listData.map(item => ({
                        text: `#${item.id} ${item.name}`,
                        value: String(item.id)
                    }))
                    this.filteredStudioList = [...this.studioList]
                }
            } catch (e) {
                console.error('获取项目列表失败', e)
            }
        },
        
        // 获取销售人员列表
        async getSaleUserList() {
            try {
                let res = await studio_api.Teaching_studio_apiIotmaxUsersGet({
                    app_id: this.$root.app_id
                })
                if (res.errcode === 0 && res.other) {
                    let listData = res.other.list || []
                    this.saleUserList = listData.map(item => ({
                        text: item.real_name || item.name,
                        value: String(item.user_id || item.id)
                    }))
                }
            } catch (e) {
                console.error('获取用户列表失败', e)
            }
        },
        
        // 发货类型确认
        onShipmentTypeConfirm() {
            const picker = this.$refs.shipmentTypePicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.shipment_type = item.value
                    this.formData.shipment_type_text = item.text
                    // 清空之前的选择
                    this.formData.record_id = ''
                    this.formData.record_name = ''
                    this.currentStockNum = 0
                    // 加载对应的列表
                    if (item.value !== 'other') {
                        this.getRecordList()
                    }
                }
            }
            this.showShipmentTypeSelect = false
        },
        
        // 获取产品/物料列表
        async getRecordList() {
            if (!this.formData.shipment_type || this.formData.shipment_type === 'other') return
            
            this.$toast.loading({ message: '加载中...', duration: 0 })
            
            try {
                let res
                if (this.formData.shipment_type === 'product') {
                    res = await studio_api.Teaching_studio_apiIotmaxProductListGet({
                        app_id: this.$root.app_id,
                        page: 1,
                        each_page: 100
                    })
                } else {
                    res = await studio_api.Teaching_studio_apiIotmaxMaterialListGet({
                        app_id: this.$root.app_id,
                        page: 1,
                        each_page: 100
                    })
                }
                
                this.$toast.clear()
                
                if (res.errcode === 0 && res.other) {
                    let listData = res.other.list || []
                    this.recordList = listData.map(item => ({
                        text: item.name,
                        value: String(item.id)
                    }))
                    this.filteredRecordList = [...this.recordList]
                    this.recordSearchKey = ''
                    this.showRecordSelect = true
                }
            } catch (e) {
                this.$toast.clear()
                console.error('获取列表失败', e)
                this.$toast('获取列表失败')
            }
        },
        
        // 过滤产品/物料列表
        filterRecordList() {
            if (!this.recordSearchKey) {
                this.filteredRecordList = [...this.recordList]
            } else {
                const key = this.recordSearchKey.toLowerCase()
                this.filteredRecordList = this.recordList.filter(item => 
                    item.text.toLowerCase().includes(key)
                )
            }
        },
        
        // 产品/物料选择确认
        onRecordConfirm() {
            const picker = this.$refs.recordPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.record_id = item.value
                    this.formData.record_name = item.text
                    this.getStockNum()
                }
            }
            this.showRecordSelect = false
        },
        
        // 获取库存数量
        async getStockNum() {
            if (!this.formData.record_id || !this.formData.shipment_type) return
            
            this.currentStockNum = 0
            
            try {
                let detailRes
                if (this.formData.shipment_type === 'product') {
                    detailRes = await studio_api.Teaching_studio_apiIotmaxProductDetailGet({
                        app_id: this.$root.app_id,
                        id: this.formData.record_id
                    })
                } else {
                    detailRes = await studio_api.Teaching_studio_apiIotmaxMaterialDetailGet({
                        app_id: this.$root.app_id,
                        id: this.formData.record_id
                    })
                }
                
                if (detailRes.errcode === 0 && detailRes.other) {
                    this.currentStockNum = detailRes.other.stock_num || 0
                }
            } catch (e) {
                console.error('获取库存失败', e)
            }
        },
        
        // 过滤项目列表
        filterStudioList() {
            if (!this.studioSearchKey) {
                this.filteredStudioList = [...this.studioList]
            } else {
                const key = this.studioSearchKey.toLowerCase()
                this.filteredStudioList = this.studioList.filter(item => 
                    item.text.toLowerCase().includes(key) || 
                    item.value.toLowerCase().includes(key)
                )
            }
        },
        
        // 项目选择确认
        onStudioConfirm() {
            const picker = this.$refs.studioPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.studio_id = item.value
                    const nameMatch = item.text.match(/^#\d+\s*(.+)/)
                    this.formData.studio_name = nameMatch ? nameMatch[1] : item.text
                }
            }
            this.showStudioSelect = false
        },
        
        // 销售人员选择确认
        onSaleUserConfirm() {
            const picker = this.$refs.saleUserPicker
            if (picker) {
                const values = picker.getValues()
                const item = values[0]
                if (item) {
                    this.formData.sale_user_id = item.value
                    this.formData.sale_user_name = item.text
                }
            }
            this.showSaleUserSelect = false
        },
        
        // 打开地区选择器
        openAreaSelect() {
            // 设置 van-area 的默认值
            if (this.formData.receiver_area_code) {
                // van-area 的 value 属性需要是区县代码（6 位）
                this.areaValue = this.formData.receiver_area_code
            } else {
                this.areaValue = ''
            }
            this.showAreaSelect = true
        },
        
        // 地区选择确认
        onAreaConfirm(values) {
            console.log('地区选择确认 values:', values)
            // values 是对象数组 [{code, name}, {code, name}, {code, name}]
            const province = values[0] || {}
            const city = values[1] || {}
            const county = values[2] || {}

            console.log('选中项:', province, city, county)

            this.formData.receiver_area = (province.name || '') + (city.name || '') + (county.name || '')
            this.formData.receiver_area_code = county.code || city.code || province.code
            this.showAreaSelect = false

            console.log('最终结果:', this.formData.receiver_area, this.formData.receiver_area_code)
        },
        
        // 提交表单
        async onSubmit() {
            // 验证必填项
            if (!this.formData.shipment_type) {
                this.$toast('请选择发货类型')
                return
            }
            if (this.formData.shipment_type !== 'other' && !this.formData.record_id) {
                this.$toast('请选择名称')
                return
            }
            if (this.formData.shipment_type === 'other' && !this.formData.custom_name) {
                this.$toast('请输入自定义名称')
                return
            }
            if (!this.formData.sale_user_id) {
                this.$toast('请选择销售人员')
                return
            }
            if (!this.formData.shipment_num) {
                this.$toast('请输入发货数量')
                return
            }
            if (parseInt(this.formData.shipment_num) <= 0) {
                this.$toast('数量必须大于 0')
                return
            }
            if (!this.formData.receiver_name) {
                this.$toast('请输入收货人姓名')
                return
            }
            if (!this.formData.receiver_tel) {
                this.$toast('请输入联系电话')
                return
            }
            if (!this.formData.receiver_area) {
                this.$toast('请选择所在地区')
                return
            }
            if (!this.formData.receiver_detail) {
                this.$toast('请输入详细地址')
                return
            }

            // 检查库存（如果是产品或物料）
            if (this.formData.shipment_type !== 'other' && this.currentStockNum > 0) {
                if (parseInt(this.formData.shipment_num) > this.currentStockNum) {
                    this.$toast(`库存不足，当前库存：${this.currentStockNum}`)
                    return
                }
            }

            // 获取 computer_code 和 salt
            const computer_code = until.getCookie("guid").substring(0, 6)

            this.$toast.loading({ message: '获取 salt...', duration: 0 })

            try {
                let saltRes = await studio_tool_api.ToolForm_saltGet({
                    computer_code: computer_code
                })

                this.$toast.clear()

                if (saltRes.errcode !== 0 || !saltRes.other) {
                    this.$toast('获取 salt 失败')
                    return
                }

                const salt = saltRes.other

                // 组装地址信息：收货人，电话，地址
                const shipment_address_info = `${this.formData.receiver_name},${this.formData.receiver_tel},${this.formData.receiver_area}${this.formData.receiver_detail}`

                // 检查是否是编辑模式
                const editId = this.$route.query.id
                const action = this.$route.query.action
                
                if (editId && action === 'edit') {
                    // 编辑模式
                    await this.updateShipment(editId, computer_code, salt, shipment_address_info)
                } else {
                    // 新增模式
                    await this.createShipment(computer_code, salt, shipment_address_info)
                }
            } catch (e) {
                this.$toast.clear()
                console.error('提交失败', e)
                this.$toast('提交失败')
            }
        },
        
        // 新增发货
        async createShipment(computer_code, salt, shipment_address_info) {
            // 准备提交数据
            const submitData = {
                app_id: this.$root.app_id,
                computer_code: computer_code,
                salt: salt,
                shipment_type: this.formData.shipment_type,
                record_id: this.formData.shipment_type !== 'other' ? parseInt(this.formData.record_id) : 0,
                shipment_num: parseInt(this.formData.shipment_num),
                studio_id: parseInt(this.formData.studio_id) || 0,
                sale_user_id: parseInt(this.formData.sale_user_id),
                shipment_address_info: shipment_address_info,
                remark: this.formData.remark || ''
            }

            // 如果是其他类型，使用自定义名称作为 intro
            if (this.formData.shipment_type === 'other') {
                submitData.intro = this.formData.custom_name
            }

            console.log('提交数据:', submitData)

            this.$toast.loading({ message: '提交中...', duration: 0 })

            let res = await studio_api.Teaching_studio_apiIotmaxShipmentAddPost(submitData)

            this.$toast.clear()

            if (res.errcode === 0) {
                this.$toast.success('提交成功')
                setTimeout(() => {
                    this.$router.back()
                }, 1500)
            } else {
                this.$toast(res.errmsg || '提交失败')
            }
        },
        
        // 更新发货
        async updateShipment(id, computer_code, salt, shipment_address_info) {
            // 准备提交数据
            const submitData = {
                app_id: this.$root.app_id,
                computer_code: computer_code,
                salt: salt,
                id: id,
                shipment_type: this.formData.shipment_type,
                record_id: this.formData.shipment_type !== 'other' ? parseInt(this.formData.record_id) : 0,
                shipment_num: parseInt(this.formData.shipment_num),
                studio_id: parseInt(this.formData.studio_id) || 0,
                sale_user_id: parseInt(this.formData.sale_user_id),
                shipment_address_info: shipment_address_info,
                remark: this.formData.remark || '',
                shipment_photos: this.formData.shipment_photos || ''
            }

            // 如果是其他类型，使用自定义名称作为 intro
            if (this.formData.shipment_type === 'other') {
                submitData.intro = this.formData.custom_name
            }

            console.log('更新数据:', submitData)

            this.$toast.loading({ message: '更新中...', duration: 0 })

            let res = await studio_api.Teaching_studio_apiIotmaxShipmentUpdatePut(submitData)

            this.$toast.clear()

            if (res.errcode === 0) {
                this.$toast.success('更新成功')
                setTimeout(() => {
                    this.$router.back()
                }, 1500)
            } else {
                this.$toast(res.errmsg || '更新失败')
            }
        }
    }
}
</script>

<style scoped>
.shipment_add {
    width: 100%;
    min-height: 100vh;
    background: #F6F6F6;
}

.detail_header {
    width: 100%;
    height: 88px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    position: sticky;
    top: 0;
    z-index: 100;
}

.back_btn i {
    font-size: 40px;
    color: #333;
}

.header_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.placeholder {
    width: 40px;
}

.form_content {
    padding: 20px;
}

.stock_hint {
    padding: 12px 16px;
    background: #FFF3E0;
    color: #FF9800;
    font-size: 24px;
    margin: 8px 16px;
    border-radius: 8px;
    font-weight: 500;
}

.submit_btn {
    margin-top: 32px;
    padding: 0 16px;
}

.picker_with_search {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.picker_with_search .van-search {
    padding: 10px 16px;
    background: #F6F6F6;
}

.picker_with_search .van-picker {
    flex: 1;
}
</style>
